<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="47.718" height="57.33" viewBox="0 0 47.718 57.33">
		<g id="Group_21335" data-name="Group 21335" transform="translate(-937.013 -348.207)">
			<g id="Group_20594" data-name="Group 20594" transform="translate(76.806 63.377)">
				<g id="Group_20547" data-name="Group 20547" transform="translate(-1390.524 118.219)">
					<g id="Group_20546" data-name="Group 20546" transform="translate(2251.524 173.329)">
						<path
							id="Path_19268"
							data-name="Path 19268"
							d="M2317.357,232.512a9.433,9.433,0,0,0,.059-1.63V209.167c0-.1,0-.2,0-.3a3.814,3.814,0,0,0-.506-1.9,4.253,4.253,0,0,0-.945-1.094l-2.791-2.409-.555-.479c-.03-.026-.133-.084-.133-.128V191.488c0-.038,0-.03-.042-.03H2299.3c-.051,0-.066-.026-.106-.061l-1.318-1.138-1.53-1.321a2.7,2.7,0,0,0-.246-.209l-.327.282-2.8,2.418c-.036.031-.045.028-.093.028h-13.144c-.035,0-.021.022-.021.055v11.359c0,.038-.169.149-.2.173l-.609.526-1.688,1.457-1,.867a4.069,4.069,0,0,0-1.1,1.413,3.816,3.816,0,0,0-.335,1.564V231.68a4.4,4.4,0,0,0,.115,1.093,3.839,3.839,0,0,0,2.271,2.6,3.941,3.941,0,0,0,1.479.275h34.968a3.807,3.807,0,0,0,3.747-3.138C2317.366,232.46,2317.353,232.531,2317.357,232.512Z"
							transform="translate(-2273.035 -187.575)"
							fill="#d1d3d4"
							style="mix-blend-mode: multiply; isolation: isolate"
						/>
						<g id="Group_20545" data-name="Group 20545" transform="translate(0 0)">
							<rect
								id="Rectangle_6981"
								data-name="Rectangle 6981"
								width="42.638"
								height="30.588"
								rx="15.294"
								transform="translate(0 15.744)"
								fill="#7daafc"
							/>
							<path
								id="Path_19269"
								data-name="Path 19269"
								d="M2287.16,172.779,2268.3,190.055c.674.608-.29,17.157.689,17.157l35.839-.864c.98,0,2.918-15.685,3.593-16.293l-18.856-17.276a1.858,1.858,0,0,0-1.013-.438A1.829,1.829,0,0,0,2287.16,172.779Z"
								transform="translate(-2267.046 -173.329)"
								fill="#7daafc"
							/>
							<g id="Group_20548" data-name="Group 20548" transform="translate(6.194 5.147)">
								<path
									id="Path_19273"
									data-name="Path 19273"
									d="M1.587,0H30.573A1.548,1.548,0,0,1,32.16,1.505V38.752a1.548,1.548,0,0,1-1.587,1.505H1.587A1.548,1.548,0,0,1,0,38.752V1.505A1.548,1.548,0,0,1,1.587,0Z"
									fill="rgba(0,0,0,0.13)"
								/>
							</g>
							<g id="Group_20542" data-name="Group 20542" transform="translate(4.93 5.147)">
								<path
									id="Path_19273-2"
									data-name="Path 19273"
									d="M1.618,0H31.16a1.565,1.565,0,0,1,1.618,1.505V38.752a1.565,1.565,0,0,1-1.618,1.505H1.618A1.565,1.565,0,0,1,0,38.752V1.505A1.565,1.565,0,0,1,1.618,0Z"
									transform="translate(0.264)"
									fill="#ff6997"
								/>
							</g>
							<g id="Group_20544" data-name="Group 20544" transform="translate(0 16.724)">
								<g id="Group_20543" data-name="Group 20543" transform="translate(0 0)">
									<path
										id="Path_19276"
										data-name="Path 19276"
										d="M2269.227,398.2a3.807,3.807,0,0,0-1.117-1.806l-16.584,14.373,1.6,1.388,0,0,15.05,12.923a3.822,3.822,0,0,0,1.187-2.772V399.228A3.868,3.868,0,0,0,2269.227,398.2Z"
										transform="translate(-2227.526 -396.392)"
										opacity="0.13"
									/>
									<path
										id="Path_19270"
										data-name="Path 19270"
										d="M2599.947,398.2a3.808,3.808,0,0,0-1.117-1.806l-12.718,11.023-3.866,3.351,1.6,1.388,0,0,15.05,12.923a3.819,3.819,0,0,0,1.187-2.772V399.228A3.868,3.868,0,0,0,2599.947,398.2Z"
										transform="translate(-2557.45 -396.391)"
										fill="#719ff8"
									/>
									<path
										id="Path_19275"
										data-name="Path 19275"
										d="M2251.667,398.2a3.807,3.807,0,0,1,1.117-1.806l16.584,14.373-1.6,1.388,0,0-15.05,12.923a3.822,3.822,0,0,1-1.187-2.772V399.228A3.868,3.868,0,0,1,2251.667,398.2Z"
										transform="translate(-2250.526 -396.391)"
										opacity="0.13"
									/>
									<path
										id="Path_19271"
										data-name="Path 19271"
										d="M2251.667,398.2a3.807,3.807,0,0,1,1.117-1.806l16.584,14.373-1.6,1.388,0,0-15.05,12.923a3.822,3.822,0,0,1-1.187-2.772V399.228A3.868,3.868,0,0,1,2251.667,398.2Z"
										transform="translate(-2251.526 -396.391)"
										fill="#719ff8"
									/>
								</g>
							</g>
						</g>
					</g>
					<path
						id="Path_19274"
						data-name="Path 19274"
						d="M2287.722,534.38,2268.3,553.17a3.818,3.818,0,0,0,2.6,1.028h35.81a3.819,3.819,0,0,0,2.6-1.028l-15.662-15.155-3.756-3.634A1.56,1.56,0,0,0,2287.722,534.38Z"
						transform="translate(-15.97 -334.693)"
						opacity="0.133"
					/>
					<path
						id="Path_19272"
						data-name="Path 19272"
						d="M2287.544,534.365,2268.3,552.49a3.838,3.838,0,0,0,2.58.991h35.482a3.84,3.84,0,0,0,2.58-.991l-15.519-14.62-3.722-3.506A1.576,1.576,0,0,0,2287.544,534.365Z"
						transform="translate(-15.782 -333.977)"
						fill="#7ba5f6"
					/>
				</g>
				<g id="Group_20566" data-name="Group 20566" transform="translate(7.383 3.68)" opacity="0">
					<line
						id="Line_330"
						data-name="Line 330"
						y1="0.995"
						transform="translate(874.663 282.15)"
						fill="none"
						stroke="#7daafb"
						stroke-linecap="round"
						stroke-miterlimit="10"
						stroke-width="2"
					/>
					<line
						id="Line_331"
						data-name="Line 331"
						y1="0.995"
						transform="translate(877.592 283.594) rotate(60)"
						fill="none"
						stroke="#7daafb"
						stroke-linecap="round"
						stroke-miterlimit="10"
						stroke-width="2"
					/>
					<line
						id="Line_332"
						data-name="Line 332"
						y1="0.995"
						transform="translate(878.317 285.805) rotate(90)"
						fill="none"
						stroke="#7daafb"
						stroke-linecap="round"
						stroke-miterlimit="10"
						stroke-width="2"
					/>
					<line
						id="Line_334"
						data-name="Line 334"
						y2="0.995"
						transform="translate(872.442 284.091) rotate(120)"
						fill="none"
						stroke="#7daafb"
						stroke-linecap="round"
						stroke-miterlimit="10"
						stroke-width="2"
					/>
					<line
						id="Line_335"
						data-name="Line 335"
						y2="0.995"
						transform="translate(871.98 285.805) rotate(90)"
						fill="none"
						stroke="#7daafb"
						stroke-linecap="round"
						stroke-miterlimit="10"
						stroke-width="2"
					/>
				</g>
			</g>
			<g id="Group_21334" data-name="Group 21334" transform="translate(707.574 -46.014)">
				<rect
					id="Rectangle_7371"
					data-name="Rectangle 7371"
					width="3.53"
					height="3.265"
					transform="translate(249.407 422.014)"
					fill="#fff"
				/>
				<path
					id="Path_19838"
					data-name="Path 19838"
					d="M251.939,410.129c-2.394,0-4.963.916-5.985,3.262a4.784,4.784,0,0,0-.374,2.044H249.6a2.591,2.591,0,0,1,.351-1.19,2.06,2.06,0,0,1,1.891-.916c1.169,0,1.852.545,1.852,1.462,0,.644-.312,1.054-1.267,1.618a6.245,6.245,0,0,0-2.01,1.5,4.435,4.435,0,0,0-.857,3.023h3.529A2.017,2.017,0,0,1,254.2,419a13.215,13.215,0,0,0,2.36-1.618,3.67,3.67,0,0,0,1.21-2.867C257.771,411.827,255.528,410.129,251.939,410.129Z"
					transform="translate(-0.153)"
					fill="#fff"
				/>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'QuestionMarkEnvelopeSVG',
};
</script>
